import { gql } from '@apollo/client';

export const cancelAutochargeEnrollment = gql`
  mutation cancelAutochargeEnrollment($input: CancelAutochargeEnrollmentInput!) {
    cancelAutochargeEnrollment(input: $input) {
      driverId
    }
  }
`;
